export default {
  step1: {
    id: 'student_offer_step1',
    defaultMessage: 'Register or Login',
  },
  step2: {
    id: 'student_offer_step2',
    defaultMessage: 'Fill in the verification form',
  },
  step3: {
    id: 'student_offer_step3',
    defaultMessage: 'Enjoy your 5% discount!',
  },
}
